export function eventMapper(trackingData) {
  let eventMapper = {};
  const mandatoryKeys = ['eventName', 'eventAction', 'eventCategory'];
  let incomingKeys = Object.keys(trackingData);
  let mandatoryEventNameAvailable = incomingKeys.includes(mandatoryKeys[0]);
  let mandatoryEventActionAvailable = incomingKeys.includes(mandatoryKeys[1]);
  let mandatoryEventCategoryAvailable = incomingKeys.includes(mandatoryKeys[2]);
  if (mandatoryEventNameAvailable === true && mandatoryEventActionAvailable === true
    && mandatoryEventCategoryAvailable === true) {
    eventMapper.event_name = trackingData.eventName;
    eventMapper.event_action = trackingData.eventAction;
    eventMapper.event_category = checkIfSet(trackingData.eventCategory);
    //optional
    eventMapper.event_custom = checkIfSet(trackingData.eventCustom);
    eventMapper.event_is_interaction = checkIfSet(trackingData.eventIsInteraction);
    eventMapper.event_label = checkIfSet(trackingData.eventLabel);
  } else {
    console.warn('sc-analytics-api: Mandatory keys and values are not correct! Make sure that "eventName", "eventAction" and "eventCategory" are sent correctly');
    eventMapper = undefined;
  }
  //console.log('eventMapper =', eventMapper);
  return eventMapper;
}

export function pageMapper(pageTrackData) {
  let pageMapper = {};
  const mandatoryKeys = ['widgetName', 'widgetTitle', 'widgetModule', 'widgetState', 'eventName'];
  let incomingKeys = Object.keys(pageTrackData);
  let mandatoryNameAvailable = incomingKeys.includes(mandatoryKeys[0]);
  let mandatoryTitleAvailable = incomingKeys.includes(mandatoryKeys[1]);
  let mandatoryModuleAvailable = incomingKeys.includes(mandatoryKeys[2]);
  let mandatoryStateAvailable = incomingKeys.includes(mandatoryKeys[3]);
  let mandatoryEventAvailable = incomingKeys.includes(mandatoryKeys[4]);

  if (mandatoryNameAvailable === true && mandatoryTitleAvailable === true
    && mandatoryModuleAvailable === true && mandatoryStateAvailable === true
    && mandatoryEventAvailable === true) {
    pageMapper.widget_name = pageTrackData.widgetName;
    pageMapper.widget_title = pageTrackData.widgetTitle;
    pageMapper.widget_module = pageTrackData.widgetModule;
    pageMapper.widget_state = pageTrackData.widgetState;
    pageMapper.event_name = checkIfSet(pageTrackData.eventName);
    //optional
    pageMapper.widget_substate = checkIfSet(pageTrackData.subState);
    pageMapper.event_custom = checkIfSet(pageTrackData.eventCustom);

    // Set the parameters requested for Backbase Forms
    if (pageTrackData.widgetName === 'backbase-forms') {
      setBackbaseFormsParameters(pageMapper, pageTrackData);
    }

    // These will be empty arrays when trackingData.products isn't available
    if (pageTrackData.productCategory !== undefined &&
      pageTrackData.productName !== undefined &&
      pageTrackData.productQuantity !== undefined &&
      pageTrackData.productPrice !== undefined) {
      pageMapper.product_category = checkIfSet(pageTrackData.productCategory);
      pageMapper.product_name = checkIfSet(pageTrackData.productName);
      pageMapper.product_quantity = checkIfSet(pageTrackData.productQuantity);
      pageMapper.product_price = checkIfSet(pageTrackData.productPrice);
    }
  } else {
    console.warn('sc-analytics-api: Mandatory keys and values are not correct! Make sure that "widgetName", "widgetTitle", "widgetModule", "widgetState" and "eventName" are sent correctly');
    pageMapper = undefined;
  }
  return pageMapper;
}

function checkIfSet(param) {
  return param || undefined;
}

// Function to set the parameters requested for Backbase Forms
function setBackbaseFormsParameters(pageMapper, pageTrackData) {
  // Set the variables for information about the form
  pageMapper.form_id = checkIfSet(pageTrackData.formId);
  pageMapper.form_processInstanceId = checkIfSet(pageTrackData.formProcessInstanceId);
  pageMapper.form_versionId = checkIfSet(pageTrackData.formVersionId);
  // Set the variables for information about the form step
  pageMapper.form_customerStepName = checkIfSet(pageTrackData.formCustomerStepName);
  pageMapper.form_technicalStepName = checkIfSet(pageTrackData.formTechnicalStepname);
  pageMapper.form_stepTechnicalIndex = checkIfSet(pageTrackData.formStepTechnicalIndex);
  pageMapper.form_stepCustomerIndex = checkIfSet(pageTrackData.formStepCustomerIndex);
  // Set the variables for information about the error related to the form
  pageMapper.form_errorLogKey = checkIfSet(pageTrackData.formErrorLogKey);
  pageMapper.form_errorDescription = checkIfSet(pageTrackData.formErrorDescription);
}
